import { queryStringToObject } from '@fiverr-private/futile/lib/url';
import _ from 'lodash';

export const Events = {
    GeneralEvents: {
        VIEWED_PAGE: 'Viewed page',
        INTERACTED: 'Interacted with reviews',
        TAG_CLICKED: 'tag clicked',
        GET_A_QUOTE_CLICKED: 'get a quote clicked',
        CONTACT_ME_CLICKED: 'contact me clicked',
        VIEWED_SELLER_PORTFOLIO: 'Viewed seller portfolio'
    }
};

export const Pages = {
    USER_PAGE: 'User profile',
    GIG_PAGE: 'Gig page'
};

export function triggerMixPanelEvent(eventName, props = {}, extraData = {}) {
    const {
            seller_card,
            buying_reviews,
            gigs,
            portfolio_projects
        } = props,
        urlParams = queryStringToObject(window.location.search.replace('?', '')),
        sourceComponent = urlParams.source
            ? { 'Source component': urlParams.source }
            : {};
    const propsData = _.isEmpty(props) ? {} : {
        'Number of gigs': gigs.length,
        'Number of pro gigs': gigs.filter((gig) => gig.is_pro).length,
        'Number of buying reviews': buying_reviews.total_count,
        'Is pro seller': seller_card.user.is_pro,
        'User Seller Level': i18n.t(`seller-levels.level-${seller_card.user.achievement || 0}`),
        'Portfolio exist': !!portfolio_projects.length
    };

    sendMixPanelEvents(eventName, {
        'Page name': Pages.USER_PAGE,
        ...propsData,
        ...sourceComponent,
        ...extraData
    });
}

export const sendMixPanelEvents = (eventName, additionalData = {}) => {
    if (typeof MixpanelWrapper !== 'undefined') {
        MixpanelWrapper.trackEvent(eventName, additionalData);
    }
};



// WEBPACK FOOTER //
// ./src/common/lib/mixpanelEvents.js